import { useToggle } from "@uidotdev/usehooks";
import { classNames } from "../utils/classNames";
import { useEffect } from "react";

export const Toggle = ({ checked, onToggle, children }) => {
  const [enabled, toggle] = useToggle(checked);
  useEffect(() => {
    onToggle(enabled);
  }, [enabled, onToggle]);
  return (
    <div
      onClick={() => toggle()}
      className="flex gap-3 items-center  print:hidden"
    >
      <div
        className={classNames(
          enabled ? "bg-primary-500" : "bg-gray-200",
          "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
        )}
      >
        <span className="sr-only">Use setting</span>
        <span
          aria-hidden="true"
          className={classNames(
            enabled ? "translate-x-5" : "translate-x-0",
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
          )}
        />
      </div>
      <label className="text-sm">{children}</label>
    </div>
  );
};
